import { render, staticRenderFns } from "./GeneralGhCalendar.vue?vue&type=template&id=a488c9f2"
import script from "./GeneralGhCalendar.vue?vue&type=script&lang=js"
export * from "./GeneralGhCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports